import { Translations } from '../app/core/interfaces/translations.interface';

export const en_GB: Translations = {
  hello_world: 'Hello World',
  users: 'Users',
  home: 'Home',
  language: 'Language'
};
